import { render, staticRenderFns } from "./WatsonsDetail.vue?vue&type=template&id=4a72882c&scoped=true&"
import script from "./WatsonsDetail.vue?vue&type=script&lang=js&"
export * from "./WatsonsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a72882c",
  null
  
)

export default component.exports